import React, { useEffect, useState } from 'react';
import { message } from 'antd';
import { useCookies } from 'react-cookie';
import { surveyApis } from 'apis/operation/surveyApis';
import CapsuleButton from 'components/button/CapsuleButton';
import DeletePopConfirm from 'components/button/DeletePopConfirm';
import DefaultLayout from 'components/layout/DefaultLayout';
import TableToolbar from 'components/table/TableToolbar';
import MainTable from 'components/table/MainTable';
import SurveyRegisterModal from './SurveyRegisterModal';
import SurveyDetailTable from './SurveyDetailTable';
import SurveyUpdateModal from './SurveyUpdateModal';
import DefaultButton from 'components/button/DefaultButton';
import { useTranslation } from 'react-i18next';
/**
 * * 운영 관리 - 설문 조사 조회
 */

const SurveyListPage = () => {
  const { t } = useTranslation();
  const [cookies] = useCookies();
  const { managementAuth } = cookies;
  const [datas, setDatas] = useState();
  const [record, setRecord] = useState();
  const [expandedRowKeys, setExpandedRowKeys] = useState([]); // 테이블 펼치기 위한 로우키;
  const [SubordinateTableData, setSubordinateTableData] = useState([]); //확장될 때 나타나는 slave테이블
  const [visible, setVisible] = useState({
    register: false,
    update: false,
  });
  const columns = [
    {
      title: t('survey.table.itemNumber'),
      dataIndex: 'survey_id',
    },
    {
      title: t('survey.table.itemName'),
      dataIndex: 'title_text',
    },
    {
      title: t('survey.table.startDate'),
      dataIndex: 'start_date',
    },
    {
      title: t('survey.table.endDate'),
      dataIndex: 'end_date',
    },
    {
      title: t('survey.table.reward'),
      children: [
        {
          title: t('survey.table.type'),
          dataIndex: 'currency',
        },
        {
          title: t('survey.table.quantity'),
          dataIndex: 'quantity',
        },
      ],
    },
    {
      title: t('survey.table.action'),
      dataIndex: 'move',
      render: (text, record, index) => {
        return (
          <div>
            {/* <CapsuleButton onClick={handleExpand(record)} name={index}>
              {record.expand === true ? '닫기' : '열기'}
            </CapsuleButton> */}
            <CapsuleButton
              name='update'
              onClick={handleVisible(record)}
              disabled={JSON.parse(managementAuth)}
            >
              {t('survey.table.edit')}
            </CapsuleButton>

            <DeletePopConfirm
              title={t('survey.table.deleteMessage')}
              onConfirm={handleDelete(record)}
              disabled={JSON.parse(managementAuth)}
            />
          </div>
        );
      },
    },
  ];

  const handleExpand = (record) => (e) => {
    setDatas(
      datas.map((v) =>
        v.id === Number(e.target.name) ? { ...v, expand: !v.expand } : v,
      ),
    );
    onExpand(true, record, e);
  };

  const handleVisible = (r) => (e) => {
    const { value, name } = e.target;
    setVisible({ ...visible, [name]: true });
    if (r) {
      setRecord(r);
    }
  };

  const onExpand = (expanded, record, e) => {
    toggleExpandByCaseId(record.survey_id);
  };

  const toggleExpandByCaseId = (v, i) => {
    if (expandedRowKeys.indexOf(v) === -1) {
      setExpandedRowKeys([...expandedRowKeys, v]); //todo 열기닫기 맞추려면 여기서 key값 조절해야함
    }
    if (expandedRowKeys.includes(v) === true) {
      setExpandedRowKeys(expandedRowKeys.filter((item) => item !== v));
    }
  };

  const expandedRowRender = (record, index, indent, expanded) => {
    let surveyArr = [];

    SubordinateTableData.map((v, i) => {
      v.map((value, index) => {
        if (value.survey_id === record.survey_id) {
          surveyArr.push(value);
        }
      });
    });
    surveyArr.map((v, i) => {
      v.key = i;
    }); //sort키 주기위해
    return (
      <SurveyDetailTable
        dataSource={surveyArr}
        surveyRecord={record}
        fetchData={fetchData}
        disabled={JSON.parse(managementAuth)}
      />
    );
  };
  const handleDelete = (record) => async () => {
    const res = await surveyApis.surveyMasterDelete(record.survey_id);
    if (!res) {
      return false;
    }
    fetchData();
    message.success('해당 설문조사를 삭제했습니다.');
  };
  const fetchData = async () => {
    const res = await surveyApis.surveyList();
    const needs = [];
    const resArr = Object.keys(res).map((key) => [res[key]]); // 테이블에 나타나야 할 값들이 있어서..2차원 배열을 평평하게 만듦
    setSubordinateTableData(Object.values(res));
    resArr.map((v, i) => {
      const forMapping = v[0];
      forMapping.map((value, index) => {
        needs.push([value][0]);
      });
    });
    //survey_id가 겹치는 애들은 한개로 묶어줌
    const unique = new Set();
    const filteredArr = needs.filter((obj) => {
      const isPresentInSet = unique.has(obj.survey_id);
      unique.add(obj.survey_id);
      return !isPresentInSet;
    });

    filteredArr.map((v, i) => {
      v.expand = false;
      v.id = i;
    });

    setDatas(filteredArr);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <DefaultLayout>
      <TableToolbar>
        <div />
        <DefaultButton
          onClick={handleVisible()}
          name='register'
          disabled={JSON.parse(managementAuth)}
        >
          {t('survey.header.addItem')}
        </DefaultButton>
      </TableToolbar>
      <MainTable
        columns={columns}
        // expandIconColumnIndex={0}
        dataSource={datas}
        onExpand={onExpand}
        // expandRowByClick={true}
        expandedRowKeys={expandedRowKeys}
        expandedRowRender={expandedRowRender}
        // expandIconAsCell={true}
        rowKey={(record) => record.survey_id}
        // dataSource={datas?.map((v, i) => datas?.[i])}
      />
      {visible.register && (
        <SurveyRegisterModal
          visible={visible.register}
          setVisible={setVisible}
          fetchData={fetchData}
          disabled={JSON.parse(managementAuth)}
        />
      )}
      {visible.update && (
        <SurveyUpdateModal
          visible={visible.update}
          setVisible={setVisible}
          fetchData={fetchData}
          record={record}
          disabled={JSON.parse(managementAuth)}
        />
      )}
    </DefaultLayout>
  );
};
export default SurveyListPage;
